const cursor = document.createElement( 'DIV' )
cursor.classList.add( 'a-cursor' )
document.body.appendChild( cursor )

const handler = e => {
  cursor.style.opacity = 1
  cursor.style.left = e.clientX + 'px'
  cursor.style.top = e.clientY + 'px'
  if( e.target.matches )
    cursor.classList.toggle( 'pointer', e.target.matches( 'a,.pointer' ) || false )
}

window.addEventListener( 'mousemove', handler )
window.addEventListener( 'mouseout', e => cursor.style.opacity = 0 )
window.addEventListener( 'mouseover', e => cursor.style.opacity = 1 )
